const budgetTypes = {
  ADD_BUDGET: "ADD BUDGET",
  GET_BUDGET: "GET BUDGET",
  GET_BUDGET_NAMES: "GET BUDGET NAMES",
  DELETE_A_BUDGET: "DELETE A BUDGET",
  GET_BUDGET_TOTAL_AMOUNT: "GET BUDGET TOTAL AMOUNT",
  GET_BUDGET_EXPENSE_TOTAL_AMOUNT: "GET BUDGET EXPENSE TOTAL AMOUNT",
};

export default budgetTypes;
